module.exports = __webpack_public_path__ + "static/media/Klymit-Web-Destop-product.0ffde0c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Klymit/Klymit-Web-Destop-product.jpg
// module id = 597
// module chunks = 0